'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _wrapDisplayName = require('recompose/wrapDisplayName');

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (stylizrInstance) {
    return function (Component) {
        var Stylized = function Stylized(props) {
            return _react2.default.createElement(Component, (0, _extends3.default)({ stylizr: stylizrInstance }, props));
        };
        Stylized.displayName = (0, _wrapDisplayName2.default)(Component, 'Stylized');

        return Stylized;
    };
};
//# sourceMappingURL=composer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-stylizr/lib/cjs/composer.js
 ** module id = 493
 ** module chunks = 1
 **/